"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWithLabel = exports._DateWithLabel = void 0;
var rc_tooltip_1 = __importDefault(require("rc-tooltip"));
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var __1 = require("../../..");
var ErrorMessage_1 = require("../../../utils/ErrorMessage");
var with_form_manager_1 = require("../../../utils/with-form-manager");
var date_component_1 = require("../../base/date/date-component");
var form_field_set_component_1 = require("../../base/form-field-set/form-field-set-component");
var label_component_1 = require("../../base/label/label-component");
var _DateWithLabel = function (_a) {
    var _b, _c, _d;
    var _e = _a.formFieldSetProps, formFieldSetProps = _e === void 0 ? {} : _e, _f = _a.dateProps, dateProps = _f === void 0 ? {} : _f, _g = _a.labelProps, labelProps = _g === void 0 ? {} : _g, id = _a.id, name = _a.name, children = _a.children, tooltip = _a.tooltip, inputProps = _a.inputProps, formManagerProps = __rest(_a, ["formFieldSetProps", "dateProps", "labelProps", "id", "name", "children", "tooltip", "inputProps"]);
    var labelRef = react_1.default.useRef(null);
    var dateRef = react_1.default.useRef(null);
    var isLabelFocused = (0, __1.useTrackFocus)(labelRef);
    var isDateFocused = (0, __1.useTrackFocus)(dateRef);
    var isFocused = isLabelFocused ||
        isDateFocused ||
        Boolean((_c = (_b = dateRef === null || dateRef === void 0 ? void 0 : dateRef.current) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.toString().trim()) ||
        Boolean((_d = formManagerProps === null || formManagerProps === void 0 ? void 0 : formManagerProps.value) === null || _d === void 0 ? void 0 : _d.toString().trim());
    var error = formManagerProps.error, errorMessage = formManagerProps.errorMessage, extraDateProps = __rest(formManagerProps, ["error", "errorMessage"]);
    var content = children;
    if (tooltip) {
        content = (react_1.default.createElement("div", { className: "flex justify-between w-full" },
            react_1.default.createElement("span", { className: "mr-2" }, children),
            react_1.default.createElement(rc_tooltip_1.default, { placement: "top", overlay: react_1.default.createElement("span", { className: "translate" }, tooltip) },
                react_1.default.createElement(react_feather_1.HelpCircle, { size: isFocused ? 16 : 20, className: "opacity-50 hover:opacity-100 " + (!isFocused ? "mr-7" : "") }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_field_set_component_1.FormFieldSet, __assign({}, formFieldSetProps, { hasError: error }),
            react_1.default.createElement(label_component_1.Label, __assign({ htmlFor: id, ref: labelRef, isFocused: isFocused }, labelProps, { hasError: error }), content),
            react_1.default.createElement(date_component_1.Date, __assign({ id: id, name: name, ref: dateRef, isFocused: isFocused, style: { outline: "none" }, hasError: error }, dateProps, extraDateProps, inputProps))),
        errorMessage && react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, errorMessage)));
};
exports._DateWithLabel = _DateWithLabel;
// const base = "fs14 w-full bg-white border-0 rounded-md block outline-none";
// const notFocused = "p-3";
// const focus = "pl-3 pb-2 pr-3";
// const getClasses = ({ isFocused }: { isFocused: boolean }) => {
//   return classNames(base, {
//     [focus]: isFocused,
//     [notFocused]: !isFocused,
//   });
// };
exports.DateWithLabel = Object.assign(exports._DateWithLabel, {
    css: {
    // base,
    // notFocused,
    // focus,
    },
    WithFormManager: (0, with_form_manager_1.withFormManager)(exports._DateWithLabel),
    displayName: "VistoDateWithLabel",
});
